// extracted by mini-css-extract-plugin
export default {"textFieldContainer":"AXCrk8","label":"MHZbAv","boxSelectionGiftCardRecipientOption":"umlNpV"};